import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Update document metadata
document.title = 'Geldhaus Africa | Business Financing Solutions for Kenyan Entrepreneurs';
// Add meta description
const metaDescription = document.querySelector('meta[name="description"]');
if (metaDescription) {
  metaDescription.setAttribute('content', 'Access flexible business financing in Kenya with Geldhaus. Fast approval (1-12 hours), competitive rates, and personalized support for SMEs. Licensed by CBK. Apply now!');
} else {
  const meta = document.createElement('meta');
  meta.name = 'description';
  meta.content = 'Access flexible business financing in Kenya with Geldhaus. Fast approval (1-12 hours), competitive rates, and personalized support for SMEs. Licensed by CBK. Apply now!';
  document.head.appendChild(meta);
}
// Add Open Graph tags
const addMetaTag = (property: string, content: string) => {
  const existing = document.querySelector(`meta[property="${property}"]`);
  if (existing) {
    existing.setAttribute('content', content);
  } else {
    const meta = document.createElement('meta');
    meta.setAttribute('property', property);
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  }
};
// Open Graph metadata
addMetaTag('og:title', 'Geldhaus Africa | Business Financing for Kenyan Entrepreneurs');
addMetaTag('og:description', 'Fast business loans in Kenya. 90% approval rate, 1-12 hour processing. Logbook loans, business loans, asset financing. Licensed by CBK.');
addMetaTag('og:type', 'website');
addMetaTag('og:url', 'https://geldhaus.africa');
addMetaTag('og:image', 'https://geldhaus.africa/og-image.jpg');
addMetaTag('og:site_name', 'Geldhaus Africa');
addMetaTag('og:locale', 'en_KE');
// Twitter Card metadata
const addTwitterTag = (name: string, content: string) => {
  const existing = document.querySelector(`meta[name="${name}"]`);
  if (existing) {
    existing.setAttribute('content', content);
  } else {
    const meta = document.createElement('meta');
    meta.setAttribute('name', name);
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  }
};
addTwitterTag('twitter:card', 'summary_large_image');
addTwitterTag('twitter:title', 'Geldhaus Africa | Business Financing for Kenyan Entrepreneurs');
addTwitterTag('twitter:description', 'Fast business loans in Kenya. 90% approval rate, 1-12 hour processing. Licensed by CBK.');
addTwitterTag('twitter:image', 'https://geldhaus.africa/og-image.jpg');
// Add canonical URL
const canonical = document.querySelector('link[rel="canonical"]');
if (canonical) {
  canonical.setAttribute('href', 'https://geldhaus.africa');
} else {
  const link = document.createElement('link');
  link.rel = 'canonical';
  link.href = 'https://geldhaus.africa';
  document.head.appendChild(link);
}
// Add theme color for mobile browsers
const themeColor = document.querySelector('meta[name="theme-color"]');
if (themeColor) {
  themeColor.setAttribute('content', '#3d8b68');
} else {
  const meta = document.createElement('meta');
  meta.name = 'theme-color';
  meta.content = '#3d8b68';
  document.head.appendChild(meta);
}
// Add keywords
const keywords = document.querySelector('meta[name="keywords"]');
if (keywords) {
  keywords.setAttribute('content', 'business loans Kenya, logbook loans, SME financing, asset financing, trade finance, Geldhaus, CBK licensed, fast approval, Kenyan entrepreneurs');
} else {
  const meta = document.createElement('meta');
  meta.name = 'keywords';
  meta.content = 'business loans Kenya, logbook loans, SME financing, asset financing, trade finance, Geldhaus, CBK licensed, fast approval, Kenyan entrepreneurs';
  document.head.appendChild(meta);
}
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-1270">
    <App data-id="element-1271" />
  </React.StrictMode>);